import EnglishLocale from './en-US.json';

const LOCALES = {
	en: 'en'
};

export const getCurrentLocaleMessages = () => EnglishLocale;

export default LOCALES;
